import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@core/environments/environment";
import { LoadingService } from "./loading.service";
import { finalize, Observable } from "rxjs";
import { Pagination } from "@core/models/pagination.model";
import { AdminNotificationListResponse } from "@core/models/admin/account/admin-notification.model";
import { AdminInboxResponse } from "@core/models/admin/account/admin-inbox.model";

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  BASE_URL = environment.ADMIN_BASE_URL + '/v1/notifications';

  http = inject(HttpClient);
  private loadingService = inject(LoadingService);

  constructor() {}

  sendPushNotification(payload: PushNotifiactionData): Observable<any> {
    const uniqueStateUrl = 'send-push-notification';
    this.loadingService.setLoading(uniqueStateUrl, true);
    return this.http
      .post<any>(this.BASE_URL + '/broadcast-message', payload)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  
  getNotifications(
    data?: Pagination,
    filter?: string
  ): Observable<AdminNotificationListResponse> {
    const uniqueStateUrl = 'get-notifications';
    this.loadingService.setLoading(uniqueStateUrl, true);

    const url = filter
      ? `${this.BASE_URL}/get-notifications?${filter}`
      : `${this.BASE_URL}/get-notifications?take=${data?.size}&skip=${data?.skip}`;

    return this.http
      .get<AdminNotificationListResponse>(url)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  getAdminNotifications(
    skip = 0,
    take = 50
  ): Observable<AdminInboxResponse> {
    return this.http.get<AdminInboxResponse>(
      `${this.BASE_URL}/get-admin-notifications?skip=${skip}&take=${take}`
    );
  }

  markNotificationRead(id: string): Observable<any> {
    return this.http.patch<any>(
      `${this.BASE_URL}/mark-as-read`,
      { id }
    );
  }

  markAllAsRead(): Observable<any> {
    return this.http.patch<any>(`${this.BASE_URL}/mark-all-as-read`, null);
  }

  uploadAdImage(formData: FormData): Observable<any> {
    const uniqueStateUrl = 'upload-ad-image';
    this.loadingService.setLoading(uniqueStateUrl, true);
    return this.http
      .post<any>(this.BASE_URL + '/upload-ad-image', formData)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
      
  }

  getNotificationEnabledAccounts(params: {
    search_text?: string;
    account_type?: string;
    skip: number;
    take: number;
  }): Observable<any> {
    const uniqueStateUrl = 'notification-enabled-accounts';
    this.loadingService.setLoading(uniqueStateUrl, true);
    const query = new URLSearchParams();
    if (params.search_text) query.set('search_text', params.search_text);
    if (params.account_type) query.set('account_type', params.account_type);
    query.set('skip', params.skip.toString());
    query.set('take', params.take.toString());
    return this.http
      .get<any>(`${this.BASE_URL}/notification-enabled-accounts?${query.toString()}`)
      .pipe(finalize(() => this.loadingService.setLoading(uniqueStateUrl, false)));
  }

  getAds(skip = 0, take = 10): Observable<any> {
    return this.http.get<any>(`${this.BASE_URL}/get-ads?skip=${skip}&take=${take}`);
  }

  deleteAd(id: string): Observable<any> {
    return this.http.delete<any>(`${this.BASE_URL}/delete-ad-image?id=${id}`);
  }
}


export interface PushNotifiactionData {
    push_type: string,
    audience: string[],
    title?: string,
    message: string,
    image_url?: string;
    action1_label?: string,
    action1_url?: string,
    action2_label?: string,
    action2_url?: string,
    specific_users?: string[],
    status?: string,
}